export function requireBrowserOrigin(message = "Browser origin is only available in browser") {
  if (typeof window === "undefined" || !window.location.origin) {
    throw new Error(message);
  }
  return window.location.origin;
}
